import { createSlice } from "@reduxjs/toolkit";

const coupaFileDeleteDetails = {
  onPage: 0,
  pageSize: 0,
  drmCoupaFileDeleteDetails: [],
  totalPages: 0,
  totalRecords: 0,
  isLoading: false,
  errorMessage: undefined,
};
    
const drmCoupaFileDeleteDetailsSlice = createSlice({
  name: "drmcoupaFileDeleteDetails",
  initialState: coupaFileDeleteDetails,
  reducers: {
    getCoupaFilesDeleteDetails: (state) => {
      state.isLoading = true;
    },
    setCoupaFilesDeleteDetailsSuccess: (state, action) => {
        return { ...state, ...action.payload, isLoading: false };
    },
    setCoupaFilesDeleteDetailsFailure: (state, action) => {
        return { ...state, errorMessage: action.payload, isLoading: false };
    },
    resetCoupaFileDeleteDetails: () => coupaFileDeleteDetails,
  },
});

export const { getCoupaFilesDeleteDetails, setCoupaFilesDeleteDetailsSuccess, setCoupaFilesDeleteDetailsFailure, resetCoupaFileDeleteDetails } = drmCoupaFileDeleteDetailsSlice.actions;
export default drmCoupaFileDeleteDetailsSlice.reducer;
